// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"style_gridContainer___SjIn","carouselContainer":"style_carouselContainer__tMMWy"};